import { useState } from "react"
import {egypts} from "../../../../data/egypts"
import ListSelect from "../../ListSelect"
import Btn from "../../Btn"

const Egypts = (props) => {

    const selectList = egypts.map(egypt => ({
        id:egypt.id,
        name:egypt.name,
        wood:egypt.wood,
        clay:egypt.clay,
        iron:egypt.iron,
        crop:egypt.crop,
        all: egypt.wood + egypt.clay + egypt.crop + egypt.iron
    }) )

    const [selectValue, setSelectValue] = useState("")
    const handleSelectValue = event => {
        setSelectValue(event.target.value)
    }

    function vypis() {
        const selectedEgypt = selectList[selectValue-1]
        props.addItem(selectedEgypt)
    }

return (
    <div>
        <ListSelect label="...choose trop..." selectList={selectList} handleSelectValue={handleSelectValue} />
        {selectValue ? (
            <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />
        ) : null}
    </div>
    )
}
export default Egypts
